export default {"src":"/_next/static/media/form-editor-pencil.d2dfebd4.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};